import { useState } from 'react'

import { Fundraiser } from '@percent/partner-dashboard/services/fundraisers/fundraisersService.types'

export function useReopenFundraiserActionModal() {
  const [selectedReopenFundraiser, setSelectedReopenFundraiser] = useState<Fundraiser | null>(null)
  const [isReopenFundraiserModalOpen, setIsReopenFundraiserModalOpen] = useState<boolean>(false)

  const openReopenFundraiserModal = (fundraiser: Fundraiser) => {
    setSelectedReopenFundraiser(fundraiser)
    setIsReopenFundraiserModalOpen(true)
  }

  const closeReopenFundraiserModal = () => {
    setIsReopenFundraiserModalOpen(false)
  }

  return {
    selectedReopenFundraiser,
    isReopenFundraiserModalOpen,
    openReopenFundraiserModal,
    closeReopenFundraiserModal
  }
}
